import type { ReactElement } from 'react';
import { Prompt, Typography } from '@weareopenr/component-library';
import styles from './DeleteSchedulePrompt.module.scss';

interface DeleteSchedulePromptProps {
  open: boolean;
  name: string;
  scheduledTime: string;
  onClose: VoidFunction;
  onConfirm: VoidFunction;
  isSubmitting: boolean;
}

export const DeleteSchedulePrompt = ({
  open,
  name,
  scheduledTime,
  onClose,
  onConfirm,
  isSubmitting,
}: DeleteSchedulePromptProps): ReactElement => (
  <Prompt
    closePrompt={onClose}
    open={open}
    buttonHandler={onConfirm}
    buttonText="Delete"
    buttonColour="tomato"
    backButton
    backButtonText="Back"
    promptHeading="Are you sure you want to delete this schedule?"
    size="small"
    isSubmitting={isSubmitting}
  >
    <div className={styles['content']}>
      <Typography>You will permanently delete the following schedule:</Typography>
      <Typography weight="semi-bold">{name}</Typography>
      <Typography>Scheduled for {scheduledTime}</Typography>
    </div>
  </Prompt>
);
